export default "Bailleurs sociaux : rénovation énergétique du parc, programmes ANAH/ANRU dédiés et primes CEE. Accompagnement de l'audit au dépôt des dossiers.";
